import React, { useEffect, useRef, useCallback, useState } from 'react';
import _ from 'lodash';
import styles from './threat-ranking-table.module.sass';
import { ReactComponent as AdvancedFilterSVG } from '../../../../assets/threat-ranking/header/advanced_filter.svg';
import { ReactComponent as CopySVG } from '../../../../assets/icons/Copy.svg';
import { ReactComponent as DownloadSVG } from '../../../../assets/icons/Download.svg';
import Icon from '@ant-design/icons';
import { Button, Radio, Input, Tooltip, Space } from 'antd';
import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined';
import mixpanel from 'mixpanel-browser';
import {
  infoNotification,
  showNotification,
} from '../../../../shared-components/Notifications';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

const ThreatRankingHeader = ({
  activeThreatRankingEndpoint,
  showAutomatedExportModal,
  showManualExportModal,
  handleClearAllClick,
  loadAdvancedFilterSidebar,
  filterSidebarOpen,
  handleNameFilterSubmit,
  handleNameFilterReset,
  handleFeedTypeFilterChange,
  setFeedStateFilterValue,
  feedStateFilterValue,
  ...props
}) => {
  const threatNameInput = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (threatNameInput) {
      threatNameInput.current.select();
    }
  }, []);

  const filterProfileApplied = useSelector(
    (state) => state?.ioc?.filterProfile,
  );
  const AdvancedFilterIcon = (props) => (
    <Icon
      component={() => (
        <AdvancedFilterSVG style={{ height: 14 }} fill={'white'} />
      )}
      {...props}
    />
  );
  const CopyIcon = (props) => (
    <Icon component={() => <CopySVG fill={'white'} />} {...props} />
  );
  const DownloadIcon = (props) => (
    <Icon component={() => <DownloadSVG fill={'white'} />} {...props} />
  );

  const filterButtonChecked = {
    background: 'rgba(60, 154, 232, 0.48)',
    borderRadius: '4px',
    border: '0',
    marginRight: 8,
  };

  const filterButtonUnchecked = {
    ...filterButtonChecked,
    background: 'rgba(255, 255, 255, 0.08)',
  };
  // eslint-disable-next-line no-unused-vars
  const [threatNameSearch, setThreatNameSearch] = useState('');
  const searchThreatName = (threatName) => {
    if (!threatName) {
      handleNameFilterReset();
    } else {
      handleNameFilterSubmit(threatName.trim());
    }
  };
  const debounceSearchThreatName = useCallback(
    _.debounce(searchThreatName, 500),
    [searchThreatName],
  );
  const handleThreatNameChange = (e) => {
    setThreatNameSearch(e.target.value);
    //debounceSearchThreatName(e.target.value);
  };

  return (
    <div className={styles.top_header}>
      <div className={styles['icon-button-section']}>
        <Space>
          <Tooltip
            placement="bottom"
            title="Export all observables and/or copy endpoint"
          >
            <Button
              type={'primary'}
              onClick={showAutomatedExportModal}
              role={'button2'}
            >
              Automate Export
            </Button>
          </Tooltip>
          <Tooltip
            placement="bottom"
            title="Export all observables into a CSV, JSON or STIX file"
          >
            <Button
              type={'primary'}
              onClick={showManualExportModal}
              role={'button3001'}
            >
              Manual Export
            </Button>
          </Tooltip>
        </Space>
      </div>
      <div
        className={styles['separator']}
        style={{ marginLeft: 24, marginRight: 16 }}
      />
      <div className={styles['input-section']}>
        <Input
          ref={threatNameInput}
          style={{
            borderRadius: '4px',
            border: '1px solid rgba(255, 255, 255, 0.3)',
          }}
          allowClear
          onPressEnter={(e) => {
            const threatName = e.target.value;
            if (!threatName) {
              handleNameFilterReset();
            } else {
              handleNameFilterSubmit(threatName.trim());
            }
          }}
          //onChange={handleThreatNameChange}
          onChange={(e) => {
            if (e.target.value === '') {
              handleNameFilterReset();
            }
          }}
          size="default"
          placeholder="Search Observable Name"
          prefix={
            <SearchOutlined style={{ color: 'rgba(255, 255, 255, 0.3)' }} />
          }
        />
      </div>
      <div
        className={styles['separator']}
        style={{ marginLeft: 16, marginRight: 16 }}
      />
      <div className={styles['clear-button-section']}>
        <Tooltip title="Clear all active filters">
          <Button
            onClick={handleClearAllClick}
            style={{ border: 0 }}
            className={styles.clear_filters}
            type="link"
          >
            Clear Filters
          </Button>
        </Tooltip>
      </div>
      <div
        className={styles['separator']}
        style={{ marginLeft: 16, marginRight: 16 }}
      />
      <div className={styles['filter-button-section']}>
        <Button
          onClick={(e) => {
            setFeedStateFilterValue('All');
            handleFeedTypeFilterChange('All');
          }}
          value="All"
          style={
            feedStateFilterValue === 'All'
              ? filterButtonChecked
              : filterButtonUnchecked
          }
        >
          <span style={{ color: '#fff' }}>All</span>
        </Button>

        <Button
          onClick={(e) => {
            setFeedStateFilterValue('Feed');
            handleFeedTypeFilterChange('Feed');
          }}
          value="Feed"
          style={
            feedStateFilterValue === 'Feed'
              ? filterButtonChecked
              : filterButtonUnchecked
          }
        >
          <span style={{ color: '#fff' }}>Feeds</span>
        </Button>

        <Button
          onClick={(e) => {
            setFeedStateFilterValue('Collection');
            handleFeedTypeFilterChange('Collection');
          }}
          value="Collection"
          style={
            feedStateFilterValue === 'Collection'
              ? filterButtonChecked
              : filterButtonUnchecked
          }
        >
          <span style={{ color: '#fff' }}>Collections</span>
        </Button>
      </div>
    </div>
  );
};

export default ThreatRankingHeader;
